import { useQuery } from '@tanstack/react-query';

import { serviceApi } from '~/features';
import { type CampaignResultsResumedModelView } from '~/types';

export const GET_PRODUCTS_RESULTS_RESUMED_QUERY_KEY =
  'GET_PRODUCT_RESULTS_RESUMED_QUERY';

export async function getProductsResultsResumed(id: string) {
  return serviceApi.get<CampaignResultsResumedModelView>(
    `/CalculoCampanhaProdutosPatrocinados/calculo-resumido?CampaignId=${id}`
  );
}

export function useGetProductResumed(id: string) {
  return useQuery({
    queryKey: [GET_PRODUCTS_RESULTS_RESUMED_QUERY_KEY, id],
    queryFn: () => getProductsResultsResumed(id),
    select: data => data.data,
  });
}
